import { Plan } from '@/types/plan';

export const plans: Plan[] = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    variant_id: import.meta.env.VITE_LEMON_SQUEEZY_FREE_VARIANT_ID,
    features: [
      'Get 200 verified leads monthly',
      '95%+ accurate, verified data',
      'Target leads with advanced tools',
      'Sync with HubSpot, Salesforce, and more'
    ],
  },
  {
    id: 'plus',
    name: 'Plus',
    price: 149,
    isPopular: true,
    variant_id: import.meta.env.VITE_LEMON_SQUEEZY_PLUS_VARIANT_ID,
    features: [
      'Get 500 verified leads monthly',
      '95%+ accurate, verified data',
      'Target leads with advanced tools',
      'Sync with HubSpot, Salesforce, and more'
    ],
  },
  {
    id: 'essential',
    name: 'Essential',
    price: 500,
    variant_id: import.meta.env.VITE_LEMON_SQUEEZY_ESSENTIAL_VARIANT_ID,
    features: [
      'Get 2000 verified leads monthly',
      '95%+ accurate, verified data',
      'Target leads with advanced tools',
      'Sync with HubSpot, Salesforce, and more'
    ],
  },
]; 